import styled from 'styled-components';
import { OffersListStyled } from '../OffersListStyled';

export const OffersListStyledDS = styled(OffersListStyled)``;
